<div class="compatibility-card">
  <ng-content></ng-content>
</div>
